import { mapValues } from "lodash-es";
import { createHttpBaseApiWrapper } from "./HttpBaseApiWrapper";
import { HttpBaseApi, endpointRegistry } from "./common.interfaces";

export const createHttpService = (): HttpBaseApi => {
  const httpServices = mapValues(endpointRegistry, (endpointUrl) =>
    createHttpBaseApiWrapper(endpointUrl),
  );

  const defaults = {
    get: httpServices.varisht.get,
    post: httpServices.varisht.post,
    put: httpServices.varisht.put,
    patch: httpServices.varisht.patch,
    delete: httpServices.varisht.delete,
  };
  return {
    ...httpServices,
    // common methods
    ...(defaults as any),
  };
};
